import React from 'react'
import { I18n } from 'react-redux-i18n'
import StarRatingComponent from 'react-star-rating-component'
import { Icon } from 'react-icons-kit'
import { androidAlert } from 'react-icons-kit/ionicons'

import { withTableConfigs } from '../../components/table'
import ReservationTableFilterPanel from './ReservationTableFilterPanel'
import ReservationTableJobAssignmentColumn from './ReservationTableJobAssignmentColumn'
import CheckInInfo from '../serviceTxn/CheckInInfo'

class ReservationTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      sizePerPage: props.sizePerPage || 50,
    }
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.notifyDataChange()
    })
  }

  handleSizePerPageChange = (e) => {
    this.setState(
      {
        sizePerPage: parseInt(e.target.value, 10),
        currentPage: 1,
      },
      () => {
        this.notifyDataChange()
      },
    )
  }

  notifyDataChange = () => {
    const { onDataChange, defaultOptions } = this.props
    const { currentPage, sizePerPage } = this.state
    if (onDataChange) {
      onDataChange({
        currentPage,
        sizePerPage,
        sort: defaultOptions.sortName,
        order: defaultOptions.sortOrder,
        filter: this.props.filter,
      })
    }
  }

  getRowBackgroundClass = (reservation) => {
    if (reservation.flag === 'overTime') {
      return 'bg-red-50'
    }
    return ''
  }

  render() {
    const {
      renderFilterPanel,
      renderToolbar,
      isCustomerSatisfactionShow = true,
      isAssignable = false,
      onAssignClick,
      onAcceptClick,
      onFeedbackClick,
      isOutTimeShow = false,
      defaultSettings,
    } = this.props

    const { currentPage, sizePerPage } = this.state
    const data = defaultSettings.data || []
    // Use totalCount from props (server-side pagination) or data.length (client-side)
    // For server-side pagination, totalCount should always be provided
    const totalCount =
      this.props.totalCount !== undefined ? this.props.totalCount : data.length

    const startIndex = (currentPage - 1) * sizePerPage
    const endIndex = Math.min(startIndex + sizePerPage, data.length)
    const displayEndIndex = Math.min(startIndex + data.length, totalCount)
    const totalPages = Math.ceil(totalCount / sizePerPage)

    const renderPageNumbers = () => {
      const pages = []
      const maxPagesToShow = 5
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => this.handlePageChange(i)}
            className={`px-3 py-1 rounded-md transition-all ${
              i === currentPage
                ? 'bg-primary-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
            }`}
          >
            {i}
          </button>,
        )
      }
      return pages
    }

    return (
      <div>
        {renderFilterPanel}
        {renderToolbar}

        <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-100 border-b border-gray-200 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    Passenger Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    Product
                  </th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider w-28">
                    Status
                  </th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider w-40">
                    Service Date/Time
                  </th>
                  {isAssignable && (
                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      Job Assignments
                    </th>
                  )}
                  {isOutTimeShow && (
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      Services & Out Time
                    </th>
                  )}
                  {isCustomerSatisfactionShow && (
                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider w-32">
                      Customer Rating
                    </th>
                  )}
                </tr>
              </thead>
              <tbody
                className="divide-y divide-gray-100"
                style={{ maxHeight: '40vh', overflowY: 'auto' }}
              >
                {data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={
                        4 +
                        (isAssignable ? 1 : 0) +
                        (isOutTimeShow ? 1 : 0) +
                        (isCustomerSatisfactionShow ? 1 : 0)
                      }
                      className="px-4 py-12 text-center text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                ) : (
                  data.map((reservation) => (
                    <tr
                      key={reservation._id}
                      className={`hover:bg-gray-50 transition-colors ${this.getRowBackgroundClass(
                        reservation,
                      )}`}
                    >
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {reservation.mainPax.fullName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {reservation.product.name}
                      </td>
                      <td className="px-4 py-3 text-sm text-center text-gray-900">
                        {reservation.status.toUpperCase()}
                      </td>
                      <td className="px-4 py-3 text-sm text-center text-gray-900">
                        {renderDateTime(reservation.serviceDateTime)}
                      </td>
                      {isAssignable && (
                        <td className="px-4 py-3 text-sm">
                          <ReservationTableJobAssignmentColumn
                            jobAssignments={reservation.jobAssignments}
                            reservation={reservation}
                            onAssignClick={onAssignClick}
                            onAcceptClick={onAcceptClick}
                          />
                        </td>
                      )}
                      {isOutTimeShow && (
                        <td className="px-4 py-3 text-sm">
                          {renderServiceTxns(reservation.relatedServiceTxns)}
                        </td>
                      )}
                      {isCustomerSatisfactionShow && (
                        <td className="px-4 py-3 text-sm text-center">
                          {renderCustomerRating(onFeedbackClick, reservation)}
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="bg-gray-100 border-t border-gray-200 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-700">Show</span>
              <select
                value={sizePerPage}
                onChange={this.handleSizePerPageChange}
                className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span className="text-sm text-gray-700">entries</span>
            </div>

            <div className="text-sm text-gray-700">
              Showing {startIndex + 1} to {displayEndIndex} of {totalCount}{' '}
              entries
            </div>

            <div className="flex items-center gap-1">
              <button
                onClick={() => this.handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded-md transition-all ${
                  currentPage === 1
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                Previous
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => this.handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 rounded-md transition-all ${
                  currentPage === totalPages
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const renderDateTime = (dateTime) => {
  return dateTime ? dateTime.format(I18n.t('date.shortDateTimeFormat')) : '-'
}

const renderServiceTxns = (serviceTxns) => {
  if (!serviceTxns) return null
  return (
    <div className="space-y-2">
      {serviceTxns.map((serviceTxn) => (
        <div key={serviceTxn._id} className="grid grid-cols-12 gap-2 text-xs">
          <div className="col-span-5">{serviceTxn.service.displayName}</div>
          <div className="col-span-5">
            <CheckInInfo serviceTxn={serviceTxn} />
          </div>
          <div className="col-span-2">
            {renderServiceInfoOutTime(serviceTxn.serviceInfo)}
          </div>
        </div>
      ))}
    </div>
  )
}

const renderServiceInfoOutTime = (serviceInfo) => {
  return serviceInfo && serviceInfo.outTime
    ? renderTime(serviceInfo.outTime)
    : null
}

const renderTime = (dateTime) => {
  return dateTime ? dateTime.format(I18n.t('date.timeFormat')) : '-'
}

const renderCustomerRating = (onFeedbackClick, reservationTxn) => {
  const { relatedServiceTxn } = reservationTxn

  if (!relatedServiceTxn || !relatedServiceTxn.serviceInfo) return null

  const customerSatisfactionRate =
    relatedServiceTxn.serviceInfo.customerSatisfactionRate

  return (
    <div className="flex items-center justify-center gap-2">
      <StarRatingComponent
        name="customerSatisfactionRate"
        value={customerSatisfactionRate}
        editing={false}
        starCount={3}
      />

      {relatedServiceTxn.alertFlag && (
        <Icon
          className="text-red-600 cursor-pointer"
          onClick={() => onFeedbackClick(relatedServiceTxn)}
          icon={androidAlert}
          size={24}
        />
      )}
    </div>
  )
}

export default withTableConfigs(ReservationTable, ReservationTableFilterPanel)
